import { Button, Callout, Dialog, EmptyState, Icon, Icons, Intent, ListItem, QueryList, Spinner, Tag } from "construct-ui";
import PosmModel from "../../models/posm/posm.model";
import ViewBase from "../../views/view-base.view";

export default function SelectWarehouseComponent() {
    ViewBase.call(this);

    const DEFAULT_ONCHANGE = (selecteditems) => { console.log('SelectWarehouseComponent: onChange(selectedItems)') };
    const TITLE_SEPARATOR = ', ';

    let searchable = true;
    let filterable = false;
    let isOpen = false;
    let isSearching = false;
    let itemList;
    let selectedItemList = [];
    let filter = { warehouseIdOrName: '', countryCode: '' };

    let clearSelectedItemList = (onChange) => () => {
        selectedItemList = [];
        onChange(selectedItemList);
    }

    let search = () => {

        isSearching = true;
        PosmModel.getWarehouseList(filter.warehouseIdOrName)
            .then((result) => {
                itemList = [...result];

            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                isSearching = false;
            })


    }

    let clearSearchFilter = () => {
        filter.warehouseIdOrName = '';
        itemList = undefined;
    }

    function renderItem(item, index) {
        return m(ListItem, {
            allowOnContentClick: true,
            label: item.warehouseName,
            selected: (selectedItemList.findIndex(i => i.warehouseID === item.warehouseID) > -1),
        })
    }

    const handleSelect = (onChange) => (item) => {
        if (item.warehouseID == "") {
            if (selectedItemList.length > 0) {
                selectedItemList.splice(0, selectedItemList.length);
            } else {
                itemList.map((item, index) => {
                    if (index > 0 && selectedItemList.findIndex(i => i.warehouseID === item.warehouseID) < 0) {
                        selectedItemList.push(item);
                    }
                });
            }
        } else if (selectedItemList.findIndex(i => i.warehouseID === item.warehouseID) > -1) {
            selectedItemList.splice(selectedItemList.findIndex(i => i.warehouseID === item.warehouseID), 1);
        } else {
            selectedItemList.push(item);
        }

        onChange(selectedItemList);
    }

    function renderSelectedLabel(item) {
        if (item.warehouseName) {
            return item.warehouseName;
        }

        let itemName = itemList?.find(i => i.warehouseID === item.warehouseID)?.warehouseName;
        if (itemName) {
            item.warehouseName = itemName;
            return itemName;
        }

        return '';
    }



    let renderLabel = (_selectedItemList) => {
        return (_selectedItemList && _selectedItemList.length > 0)
            ? _selectedItemList.length + ' ' + this.getText("LT00000308", "item(s) selected")
            : ''
    }

    const renderTitle = _selectedItemList => {
        return (_selectedItemList && _selectedItemList.length > 0)
            ? _selectedItemList.map(warehouse => warehouse.warehouseName).join(TITLE_SEPARATOR)
            : ''
    }

    const readOnly = (event) => {
        event.preventDefault();
        event.stopImmediatePropogation();
    }


    let Content = {
        view: ({ attrs: { disabled, onChange } }) => {
            return m('.container',
                // Selected section
                m('.d-flex.justify-content-between.gap-2',
                    m('.d-flex.gap-2',
                        m('label.form-label', this.getText("LT00000343", "Selected items")),
                        (selectedItemList && selectedItemList.length > 0)
                            ? [m('span', ':'), m('span', selectedItemList.length + ' ' + this.getText("LT00000344", "items"))]
                            : ''
                    ),
                    m('.d-flex.gap-2',
                        m('a.btn.btn-link.p-0', {
                            onclick: clearSelectedItemList(onChange)
                        }, this.getText("LT00000345", "Clear all")),
                    )
                ),
                m('.card.mb-3',
                    m('.card-body.overflow-auto', { style: 'min-height: 51px; max-height: 82px;' },
                        m('.d-flex.flex-wrap.gap-1',
                            (selectedItemList && selectedItemList.length > 0)
                                ? selectedItemList.map(i => [
                                    m(Tag, {
                                        class: 'm-0',
                                        label: renderSelectedLabel(i),
                                        onRemove: e => {
                                            let idx = selectedItemList.findIndex(s => s.warehouseID === i.warehouseID);
                                            if (idx > -1) {
                                                selectedItemList.splice(idx, 1);
                                                onChange(selectedItemList);
                                            }
                                        }
                                    })
                                ])
                                : m(EmptyState, {
                                    content: this.getText("LT00000318", "No items selected. Please search and select from the section below."),
                                    style: 'color: var(--is-inactive-gray)',
                                })
                        ),
                    )
                ),
                // Search section
                m('.card.mb-3',
                    m('.card-body',
                        m('.row.g-4',
                            searchable && m('.col-12',
                                m('.d-flex.flex-wrap.justify-content-end.gap-2',
                                    m('.flex-grow-1', { style: 'min-width: 60%;' },
                                        m('input.form-control[type=text]', {
                                            placeholder: this.getText("LT00001212", "Warehouse ID Or Name"),
                                            onchange: e => { filter.warehouseIdOrName = e.target.value },
                                            value: filter.warehouseIdOrName,
                                        }),
                                    ),
                                    m('.d-flex.gap-2',
                                        m(Button, {
                                            label: this.getText("LT00000001", "Search"),
                                            intent: Intent.PRIMARY,
                                            loading: isSearching,
                                            onclick: search,
                                        }),
                                        m(Button, {
                                            label: this.getText("LT00000031", "Clear"),
                                            intent: Intent.PRIMARY,
                                            outlined: true,
                                            onclick: clearSearchFilter,
                                        }),
                                    ),
                                ),
                            ),
                            m('.col-12.position-relative', { style: 'min-height: 180px;' },
                                itemList && itemList.length > 0
                                    ? m(QueryList, {
                                        filterable: filterable,
                                        items: itemList,
                                        itemRender: renderItem,
                                        itemListPredicate: (query, items) => items.filter(i => i.warehouseName.toLowerCase().includes(query.toLowerCase())),
                                        onSelect: handleSelect(onChange),
                                        listAttrs: {
                                            style: 'height: calc(100vh - 520px);'
                                        }
                                    })
                                    : m(EmptyState, {
                                        icon: Icons.ARCHIVE,
                                        content: this.getText("LT00000317", "No results found"),
                                        fill: true,
                                        style: 'color: #B5B5B5',
                                    }),
                                isSearching &&
                                m(Spinner, {
                                    active: isSearching,
                                    background: true,
                                    fill: true,
                                    size: 'xl',
                                })
                            )
                        )
                    )
                ),
                itemList && itemList.length > 199 &&
                m(Callout, {
                    content: this.getText("LT00000320", "Only top 200 records are shown due to large result set"),
                    icon: Icons.ALERT_CIRCLE,
                    intent: Intent.WARNING,
                })
            )
        }
    }

    return {
        oninit: (vnode) => {
            if (vnode.attrs.selectedItems) {
                selectedItemList = vnode.attrs.selectedItems;
                //getMissingwarehouseIdOrNames();
            }

            filter.countryCode = vnode.attrs.countryCode ?? '';
            searchable = vnode.attrs.searchable ?? searchable;

            // Only allow external list if not searchable
            if (!searchable) {
                itemList = vnode.attrs.items ?? []
            }

            filterable = vnode.attrs.filterable ?? filterable;

            search();
        },
        onupdate: (vnode) => {
            // Only allow external list if not searchable
            if (!searchable) {
                itemList = vnode.attrs.items ?? itemList ?? [];
            }

            if ((typeof vnode.attrs.countryCode === 'string' || vnode.attrs.countryCode instanceof String)
                && filter.countryCode !== vnode.attrs.countryCode) {
                filter.countryCode = vnode.attrs.countryCode;
                search();
            }

            selectedItemList = vnode.attrs.selectedItems ?? selectedItemList;
            //getMissingwarehouseIdOrNames();
        },
        view: ({ attrs: {
            id = null,
            required = false,
            disabled = false,
            placeholder = null,
            selectedItems = [],
            onChange = DEFAULT_ONCHANGE
        } }) => {
            return [
                m('.select-input-component.d-flex.justify-content-between.align-items-center.form-control.form-control-bg', {
                    class: disabled ? 'disabled ' : '',
                    onclick: () => {
                        if (!disabled) {
                            isOpen = !isOpen;
                        }
                    }
                },
                    m('input.flex-fill.text-start.ps-0', {
                        id,
                        disabled,
                        required,
                        type: 'text',
                        placeholder: placeholder || this.getText("LT00000201", "Please select"),
                        oninput: readOnly,
                        style: {
                            width: 'inherit',
                            'overflow-x': 'hidden',
                            'text-overflow': 'ellipsis',
                            border: 'none',
                            background: 'transparent'
                        },
                        value: renderLabel(selectedItems),
                        title: renderTitle(selectedItems)
                    }),
                    m(Icon, { name: Icons.LIST, intent: Intent.PRIMARY })
                ),
                isOpen &&
                m(Dialog, {
                    class: 'cui-dialog-l',
                    closeOnOutsideClick: false,
                    isOpen: isOpen,
                    onClose: () => isOpen = false,
                    title: this.getText("LT00001269", "Warehouse"),
                    content: m(Content, { onChange })
                })
            ]
        }
    }
}
